
// import { Routes, Route, useLocation } from 'react-router-dom';
// import Login from './pages/login/Login';
// import Home from './pages/home/Home';
// import Nav from './pages/nav/Nav';
// import './App.css'; // Make sure this imports your CSS
// import Payment from './pages/home/Payment';

// function App() {
//   const location = useLocation();
//   const showNav = location.pathname !== '/login';

//   return (
//     <div className="app-container">
//       {showNav && <Nav />}
//       <main className={`main-content ${showNav ? 'with-nav' : ''}`}>
//         <Routes>
//           <Route path="/login" element={<Login />} />
//           <Route path="/" element={<Login />} />
//           <Route path="/home" element={<Home />} />
//           <Route path="/Payment" element={<Payment />} />
//         </Routes>
//       </main>
//     </div>
//   );
// }

// export default App;


import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/Login';
import Home from './pages/home/Home';
import Nav from './pages/nav/Nav';
import Payment from './pages/home/Payment';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  const location = useLocation();
  const showNav = location.pathname !== '/login';

  return (
    <div className="app-container">
      {showNav && <Nav />}

      <main className={`main-content ${showNav ? 'with-nav' : ''}`}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />

          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;